import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { ApiEndpoints } from 'meta/api'
import { Project } from 'meta/project/project'
import { Story } from 'meta/story/story'

export const storyApi = createApi({
  reducerPath: 'story',
  baseQuery: fetchBaseQuery(),
  endpoints: (build) => ({
    getStory: build.query<Story, { projectName: Project['name']; storyName: Story['name'] }>({
      query: ({ projectName, storyName }) => ApiEndpoints.Stories.one(projectName, storyName),
    }),
  }),
})
